import type { TourDefinition } from './types';

/** First-login Home coachmarks: Sell + My Journey + notifications + help. */
export const homeTour: TourDefinition = {
    id: 'home',
    steps: [
        {
            id: 'home.sell',
            target: [
                // Mobile bottom-nav Sell first when visible
                '[data-tour-id="home.sell.mobile"]',
                '[data-tour-id="home.sell"]',
            ],
            titleKey: 'tour.home.sell.title',
            bodyKey: 'tour.home.sell.body',
            titleFb: 'Sell an item',
            bodyFb: 'List baby gear in minutes via the Sell button.',
            placement: 'top',
            // Sit 8px above sticky bottom nav (measured); tight ring around the Sell pill only
            anchor: 'bottom-nav',
            anchorGapPx: 8,
            spotlightPadding: 2,
            primaryAction: {
                labelKey: 'tour.home.sell.cta',
                labelFb: 'List an item',
                href: '/sell',
            },
        },
        {
            id: 'home.journey',
            target: [
                // Edge tab (desktop/logged-in) first when visible; bottom-nav fallback on phone
                '[data-tour-id="home.journey"]',
                '[data-tour-id="home.journey.mobile"]',
            ],
            titleKey: 'tour.home.journey.title',
            bodyKey: 'tour.home.journey.body',
            titleFb: 'My Journey',
            bodyFb: 'Add your baby and explore what they need for their age.',
            placement: 'left',
            // Tight pad; ring uses the control's real radii (rounded-l-xl, flush right)
            spotlightPadding: 3,
        },
        {
            id: 'home.notifications',
            target: ['[data-tour-id="home.notifications"]'],
            titleKey: 'tour.home.notifications.title',
            bodyKey: 'tour.home.notifications.body',
            titleFb: 'Notifications',
            bodyFb:
                'Get notified about orders and activity from people you follow — open the bell anytime.',
            // Sit just under the bell (mobile prod) — not mid-page
            placement: 'bottom',
            spotlightPadding: 3,
        },
        {
            id: 'home.help',
            target: ['[data-tour-id="tour.help"]'],
            titleKey: 'tour.home.help.title',
            bodyKey: 'tour.home.help.body',
            titleFb: 'Need a refresher?',
            bodyFb: 'Tap the ? anytime to replay this tour.',
            // Same as prod: card under the ? control (left placement was clamping mid-screen on mobile)
            placement: 'bottom',
            spotlightPadding: 3,
        },
    ],
};
